import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditWorkForm } from "../../components/worker";

export const AddEditWork = () => {
  const { id } = useParams();
  const location = useLocation();
  const [isGroupWork, setIsGroupWork] = React.useState(false);
  const isEntryPath = location.pathname.includes("/entry");

  const chipItems = [
    { label: "Multiple Work", onClick: () => setIsGroupWork(false) },
    { label: "Group Work", onClick: () => setIsGroupWork(true) },
  ];

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          title={id ? "Edit Work" : "Add Work"}
          chipItems={!id && isEntryPath ? chipItems : undefined}
          activeTab={isGroupWork ? "group work" : "multiple work"}
        />
      </Box>

      <Box sx={{ mt: -4, zIndex: 2, position: "relative" }}>
        <AddEditWorkForm workId={id} key={isGroupWork ? "group" : "multiple"} isGroupWorkerMode={isGroupWork} />
      </Box>
    </PageLayout>
  );
};
